import styled from 'styled-components';

const ImagePreviewButton = styled.button`
  position: relative;
  z-index: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  height: ${props => props.height || '150px'};
  width: ${props => props.width || '320px'};
  padding: 0;
  margin: 24px auto;
  border: none;
  cursor: ${props => (props.disabled ? 'not-allowed' : 'pointer')};
  border-radius: ${props => (props.avatar ? '100%' : '3px')};
  overflow: hidden;
  background-color: rgba(0, 0, 0, 0.1);
  box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.02), 0 2px 10px 0 rgba(0, 0, 0, 0.04);
  transition: all 300ms ease-out;

  &:hover {
    background-color: ${props => !props.disabled && 'rgba(0, 0, 0, 0.2)'};
  }
`;

export default ImagePreviewButton;
